<template>
  <div id='pest-map-view'>
    <report-infestation-modal/>
    <div class="mdl-grid">
      <div class="mdl-cell mdl-cell--6-col">
        <!-- Left aligned menu below button -->
        <button id="demo-menu-lower-left"
                class="mdl-button mdl-js-button mdl-button--icon">
          <i class="material-icons">more_vert</i>
        </button>

        <ul class="mdl-menu mdl-menu--bottom-left mdl-js-menu mdl-js-ripple-effect"
            for="demo-menu-lower-left">
          <li class="mdl-menu__item">Report an infestation</li>
          <li class="mdl-menu__item mdl-menu__item--full-bleed-divider">Center map</li>
          <li disabled class="mdl-menu__item">Disabled Action</li>
          <li class="mdl-menu__item">Yet Another Action</li>
        </ul>

        <ripple-button
          @click.native="showReportModal()"
          >
          Report an infestation
        </ripple-button>
      </div>
      <div class="mdl-cell mdl-cell--6-col">
        <ripple-button
          @click.native="centerOnLocation()"
        >
          Center on current location
        </ripple-button>
    </div>
    </div>
    <div v-if="center">
      <div class='pest-map' id='pest-map'>
        <gmap-map
          :center="center"
          :zoom="16"
          ref="pestsMap"
          map-type-id="hybrid"
          style="width: 100%; height: 100%"
        >
          <gmap-marker v-for="(location, index) in reportedLocations"
            :key="index"
            :position="location"
            :clickable="true"
            @click="selectReportedLocation(index)"
          >
          </gmap-marker>
        </gmap-map>
      </div>
    </div>
    <div v-else class='pest-map' id='pest-map'>
        <gmap-map
          :center="bugtown"
          :zoom="15"
          ref="pestsMap"
          map-type-id="hybrid"
          style="width: 100%; height: 100%"
        >
          <gmap-marker v-for="(location, index) in reportedLocations"
            :key="index"
            :position="location"
            :clickable="true"
            @click="selectReportedLocation(index)">
          </gmap-marker>
        </gmap-map>
    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import { mapState } from 'vuex'

import ReportInfestationModal from '@/components/ReportInfestationModal'
import RippleButton from '@/components/RippleButton'

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.GOOGLE_MAPS_API_KEY,
    libraries: [
      'places'
    ]
  }
})

export default {
  name: 'pest-map',

  data () {
    return {
      bugtown: { lat: 38.150556, lng: -87.840278 },
      centered: false
    }
  },

  components: {
    ReportInfestationModal,
    RippleButton
  },

  computed: {
    ...mapState({
      center: state => state.locations.currentLocation,
      reportedLocations: state => state.locations.reportedLocations
    })
  },

  methods: {
    centerOnLocation () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          this.$refs.pestsMap.$mapCreated.then(() => {
            console.log('map ready to center on location')
            this.$store.dispatch('setCurrentLocation', position)
            this.$refs.pestsMap.resizePreserveCenter()
            Vue.$gmapDefaultResizeBus.$emit('resize')
          })
        })
      }
    },
    showReportModal () {
      console.log('clicked showReportModal')
      this.$modal.show('report-infestation')
    },
    selectReportedLocation (index) {
      console.log('clicked selectReportedLocation with index', index)
    }
  },

  mounted: function () {
    this.centerOnLocation()
  },

  watch: {
    reportedLocations: function () {
      this.$refs.pestsMap.$mapCreated.then(() => {
        Vue.$gmapDefaultResizeBus.$emit('resize')
      })
    }
  }
}
</script>

<style scoped>
  .pest-map {
    height: 750px;
    margin: 0 auto;
    background: gray;
    padding: 1px;
  }

  .address-lookup-input {
    width: 59%;
    margin: 0 auto;
  }
  .address-lookup-label {
    width: 39%
  }
</style>



// WEBPACK FOOTER //
// src/components/PestMap.vue